import React from 'react';

export default function BackgroundImage() {
  return (
    <div className="w-full ">
      <img
        className="w-full object-cover h-[50vh]"
        alt="earth"
        src="https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=4171&q=80"
      />
    </div>
  );
}
